import { ShieldCheck, MapPin, CreditCard, Stethoscope, Flag, BadgeCheck } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";
import { useSiteEmails, useInfoPage, pick } from "../lib/siteContent";
import { InfoPageSkeleton } from "../components/InfoPageSkeleton";

const ICONS = [MapPin, CreditCard, Stethoscope, BadgeCheck];

export default function TrustSafety() {
  const emails = useSiteEmails();
  const { lang } = useLanguage();
  const page = useInfoPage("trust");
  if (!page) return <InfoPageSkeleton testid="trust-safety-page" />;
  const f = (k) => pick(page.fields[k], lang);
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12" data-testid="trust-safety-page">
      <span className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-widest text-[#F5551E] bg-[#FFF4F0] rounded-full px-3 py-1"><ShieldCheck size={13} /> {f("badge")}</span>
      <h1 className="font-display font-extrabold text-4xl text-[#12234A] mt-4" data-testid="trust-title">{f("title")}</h1>
      <p className="text-base text-slate-600 mt-5">{f("intro")}</p>

      <div className="mt-8 grid sm:grid-cols-2 gap-4">
        {page.sections.map((t, i) => {
          const Icon = ICONS[i % ICONS.length];
          return (
            <section key={`${i}-${t.h.en}`} data-testid={`trust-tip-${i}`} className="rounded-2xl border border-slate-100 bg-white p-5">
              <span className="h-11 w-11 rounded-xl bg-[#FFF4F0] flex items-center justify-center text-[#F5551E]"><Icon size={22} /></span>
              <h2 className="font-display font-bold text-lg text-[#12234A] mt-3">{pick(t.h, lang)}</h2>
              <p className="text-sm text-slate-600 mt-1.5 leading-relaxed whitespace-pre-line">{pick(t.p, lang)}</p>
            </section>
          );
        })}
      </div>

      {page.list?.length > 0 && (
        <div className="mt-8 rounded-2xl bg-amber-50 border border-amber-100 p-6" data-testid="trust-signs">
          <h2 className="font-display font-bold text-lg text-[#12234A]">{f("signs_title")}</h2>
          <ul className="mt-3 space-y-2">
            {page.list.map((s, i) => (
              <li key={`${i}-${s.en}`} className="flex gap-2.5 text-sm text-slate-700"><span className="text-amber-500 mt-0.5">•</span><span>{pick(s, lang)}</span></li>
            ))}
          </ul>
        </div>
      )}

      <div className="mt-8 rounded-2xl bg-[#F8FAFC] border border-slate-100 p-6">
        <div className="flex items-center gap-2">
          <Flag size={18} className="text-[#F5551E]" />
          <h2 className="font-display font-bold text-lg text-[#12234A]">{f("report_title")}</h2>
        </div>
        <p className="text-sm text-slate-600 mt-2 leading-relaxed">{f("report_p_1")} <a href={`mailto:${emails.contact}`} className="text-[#F5551E] font-semibold hover:underline" data-testid="site-contact-email">{emails.contact}</a>. {f("report_p_2")}</p>
      </div>
    </div>
  );
}
